module.exports = __webpack_public_path__ + "img/Bodice-Back-Jc-fabric straps-Ka-Lb.35bfb36a.png";